"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.createVFSTransport = void 0;
var lodash_1 = require("lodash");
var getSchemaFilePath = function (collectionId) {
    return ".schemas/" + collectionId + ".json";
};
exports.createVFSTransport = function (editorSDK, token) {
    var vfs = editorSDK.vfs;
    var saveSiteIfNeeded = function () {
        return editorSDK.info
            .isSiteSaved(token)
            .then(function (isSiteSaved) {
            return isSiteSaved
                ? Promise.resolve()
                : editorSDK.document.save(token)["catch"](function () { });
        });
    };
    var listSchemas = function () {
        return vfs
            .listChildren(token, { path: '.schemas' })
            .then(function (children) {
            return Promise.all(children
                .filter(function (_a) {
                var isDirectory = _a.isDirectory;
                return isDirectory;
            })
                .map(function (directory) {
                return vfs
                    .listChildren(token, { path: directory.fullPath })
                    .then(function (children) {
                    return children.map(function (file) { return (__assign(__assign({}, file), { name: directory.name + "/" + file.name })); });
                });
            })).then(function (directories) {
                return lodash_1.flatten(children.map(function (file) {
                    return file.isDirectory ? directories.shift() : file;
                })).filter(function (file) { return file.name.endsWith('.json'); });
            });
        })
            .then(function (schemaFiles) {
            return Promise.all(schemaFiles.map(function (file) { return loadSchema(file.name.replace('.json', '')); }));
        });
    };
    var loadSchema = function (collectionId) {
        return vfs
            .readFile(token, { path: getSchemaFilePath(collectionId) })
            .then(JSON.parse);
    };
    var saveSchema = function (collectionId, schema) {
        return saveSiteIfNeeded().then(function () {
            return vfs
                .writeFile(token, {
                path: getSchemaFilePath(collectionId),
                content: JSON.stringify(schema)
            })
                .then(function () { return vfs.flush(token); });
        });
    };
    var removeSchema = function (collectionId) {
        return saveSiteIfNeeded().then(function () {
            return vfs
                .deleteFile(token, {
                path: getSchemaFilePath(collectionId)
            })
                .then(function () { return vfs.flush(token); });
        });
    };
    return {
        listSchemas: listSchemas,
        loadSchema: loadSchema,
        saveSchema: saveSchema,
        removeSchema: removeSchema
    };
};
//# sourceMappingURL=vfsTransport.js.map